import CentreonIcon from "@components/icons/CentreonIcon";
import ConfigurationsIcon from "@components/icons/ConfigurationsIcon";
import CreditLimitIcon from "@components/icons/CreditLimitIcon";
import DistributorIcon from "@components/icons/DistributorIcon";
import FilteringIcon from "@components/icons/FilteringIcon";
import ManagementPoolIcon from "@components/icons/ManagementPoolIcon";
import NetworkIcon from "@components/icons/Networkcon";
import ProjectIcon from "@components/icons/ProjectIcon";
import VoucherIcon from "@components/icons/VoucherIcon";
import { useIsMobile } from "@components/mediaQuery/useIsMobile";
import { useFeatureIsOn, useFeatureValue } from "@growthbook/growthbook-react";
import {
	IS_ACTIVATION_ROLE,
	IS_ADMIN_ROLE,
	IS_DISTRIBUTOR_ROLE,
	IS_RESELLER_ROLE,
	IS_SALES_STAFF_ROLE,
} from "@utils/user_roles";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo/iec_logo.png";
import { FLAGS } from "../../config/growthbook/flags.js";
import { closeSidebar, setSelectedModule } from "../../store/modules/sidebarSlice";
import Account_managementIcon from "../icons/Account_managementIcon"; // Import your icon component
import BillingIcon from "../icons/BillingIcon";
import DashboardIcon from "../icons/DashboardIcon";
import LogsIcon from "../icons/LogsIcon";
import Prov_managementIcon from "../icons/Prov_managementIcon";
import StockIcon from "../icons/StockIcon";
import VesselsIcon from "../icons/VesselsIcon";

const Sidebar = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [isMdScreen, setIsMdScreen] = useState(false);

	const { isOpen, selectedModule } = useSelector((state) => state.modules.sidebar);
	const { token, role, distributor, business_units } = useSelector((state) => state.auth.user);

	const modules = useSelector((state) => state.auth.user.permissions);
	const userEmail = useSelector((state) => state.auth.user.email);
	const distributorname = useSelector((state) => state.auth.user?.distributor?.name);

	const distributorAllowlist = useFeatureValue(FLAGS.sidebar.adminAccess.distributorAllowlist, []);

	const usersVisible = useFeatureIsOn(FLAGS.sidebar.accountManagement.usersVisible);

	const isAdmin =
		role?.id === IS_ADMIN_ROLE ||
		role?.parent_id === IS_ADMIN_ROLE ||
		role?.id === IS_SALES_STAFF_ROLE ||
		role?.id === IS_ACTIVATION_ROLE ||
		(role?.parent_id === null &&
			role?.id === IS_DISTRIBUTOR_ROLE &&
			distributorAllowlist.includes(distributorname));

	const isDistributor = role?.parent_id === IS_DISTRIBUTOR_ROLE;

	// role?.id === IS_DISTRIBUTOR_ROLE ||

	const isTechAdmin = userEmail === "technical_customer@iec-telecom.com";

	const modulesToDisplay = modules?.filter((module) => {
		// if (
		//   module.resource_name === "project_overview"
		// ) {
		//   return false;
		// }
		return true;
	});

	const isMobile = useIsMobile();

	const navigatePaths = {
		dashboard: "/",
		vessels_site: "/vessels_site",
		stock: "/stock",
		account_management: "#",
		prov_management: "#",
		account_management_users: "/account_management_users",
		account_management_roles: "/account_management_roles",
		business_units: "/business_units",
		clients: "/clients",
		profile: "/profile",
		iec_voucher_manager: "/iec_voucher_manager",
	};

	const lists = [
		"prov_management",
		"billing",
		"configurations",
		"filtering_management",
		"credit_limit_management",
		"centreon",
		"iec_voucher_manage",
	];

	const handleModuleClick = (name, display_name) => {
		dispatch(setSelectedModule({ name, display_name }));
		dispatch(closeSidebar());
		const path = navigatePaths[name] || `/${name}`;
		navigate(path);
	};

	const getIconComponent = (moduleName) => {
		const isSelected = selectedModule?.name === moduleName;

		const iconClasses = `w-5 h-5 transition duration-75 ${
			isSelected ? "text-white" : "text-blue-gray group-hover:text-white"
		}`;

		const icons = {
			dashboard: <DashboardIcon className={iconClasses} />,
			stock: <StockIcon className={iconClasses} />,
			vessels_site: <VesselsIcon className={iconClasses} />,
			project_overview: <ProjectIcon className={iconClasses} />,
			management_pool: <ManagementPoolIcon className={iconClasses} />,
			distributor_pool: <DistributorIcon className={iconClasses} />,
			account_management: <Account_managementIcon className={iconClasses} />,
			prov_management: <Prov_managementIcon className={iconClasses} />,
			logs: <LogsIcon className={iconClasses} />,
			billing: <BillingIcon className={iconClasses} />,
			configurations: <ConfigurationsIcon className={iconClasses} />,
			network_management: <NetworkIcon className={iconClasses} />,
			credit_limit_management: <CreditLimitIcon className={iconClasses} />,
			filtering_management: <FilteringIcon className={iconClasses} />,
			centreon: <CentreonIcon className={iconClasses} />,
			iec_voucher_manager: <VoucherIcon className={iconClasses} />,
		};
		return icons[moduleName] || null;
	};

	useEffect(() => {
		const updateScreenSize = () => {
			setIsMdScreen(window.innerWidth >= 768); // md breakpoint is 768px in Tailwind CSS
		};

		updateScreenSize(); // Initial check
		window.addEventListener("resize", updateScreenSize);

		return () => {
			window.removeEventListener("resize", updateScreenSize);
		};
	}, []);

	return (
		<aside
			id="logo-sidebar"
			className={`fixed top-0 left-0 z-40 h-screen w-64 space-y-3 bg-dark-blue transition-transform sm:h-[calc(100vh-64px)] md:h-screen" ${isOpen ? "translate-x-0" : "-translate-x-full"} sm:translate-x-0`}
			aria-label="Sidebar"
		>
			<div className="h-full bg-dark-blue px-2 pb-4 max-sm:pt-16 sm:pt-0">
				<ul className="space-y-11 font-normal">
					{!isMobile && (
						<div>
							{(role?.id == IS_DISTRIBUTOR_ROLE ||
								role?.parent_id == IS_DISTRIBUTOR_ROLE ||
								Number(role?.id) === Number(IS_RESELLER_ROLE) ||
								role?.parent_id == IS_RESELLER_ROLE) &&
							distributor?.photo ? (
								<a href="" className="flex w-full justify-center">
									<img
										src={`${distributor.photo}`}
										alt={distributor.name}
										className="h-11 pt-1.5"
									/>
								</a>
							) : (
								<a
									href={`${import.meta.env.VITE_IEC_WEBSITE}`}
									target="_blank"
									rel="noopener noreferrer"
									className="ms-2 flex"
								>
									<img src={logo} alt="Logo" className="h-11 pt-1.5" />
								</a>
							)}
						</div>
					)}
					<div
						className={`custom-scrollbar h-[calc(100vh-115px)] space-y-2 overflow-y-auto font-normal ${isMobile ? "mt-6" : null} `}
					>
						{modulesToDisplay &&
							modulesToDisplay.map(
								(module, i) =>
									module.authorized && (
										<li
											key={i}
											className={`${lists.includes(module?.resource_name) && (role?.parent_id == IS_ADMIN_ROLE || role?.parent_id == IS_ACTIVATION_ROLE) ? "pointer-events-none opacity-50" : ""}`}
										>
											<details className="group px-1 [&_summary::-webkit-details-marker]:hidden">
												<summary
													className={`group flex cursor-pointer items-center rounded-lg p-0.25 text-white ${
														selectedModule?.display_name === module?.display_name
															? "text-wrap bg-blue-gray bg-opacity-20"
															: "text-white hover:bg-blue-gray hover:bg-opacity-20"
													}`}
													onClick={() => {
														module?.display_name !== null &&
															!(module?.sub_resources?.length > 0) &&
															handleModuleClick(module?.resource_name, module?.display_name);
													}}
												>
													<span className="flex items-center">
														{getIconComponent(module?.resource_name, selectedModule)}
														<span className="ml-[0.3rem]">{module?.display_name}</span>
														{module?.sub_resources && module?.sub_resources.length > 0 && (
															<svg
																xmlns="http://www.w3.org/2000/svg"
																className={"ml-[2px]] w-4"}
																viewBox="0 0 20 20"
																fill="currentColor"
															>
																<path
																	fillRule="evenodd"
																	d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
																	clipRule="evenodd"
																/>
															</svg>
														)}
													</span>
												</summary>
												{/* Map over Sub-permissions */}
												<ul className="mt-1 space-y-1 pl-7" id={`module-${module?.id}`}>
													{module.sub_resources &&
														module.sub_resources.map(
															(sub) =>
																sub.authorized &&
																(sub.display_name === "Users"
																	? isAdmin ||
																		(usersVisible &&
																			role?.parent_id === null &&
																			role?.id === IS_DISTRIBUTOR_ROLE) ||
																		(["ADISTA"].includes(business_units?.[0]?.name) &&
																			role?.id === IS_RESELLER_ROLE)
																	: true) && (
																	<li
																		className="pt-[1.72px]"
																		key={`${module?.id || module?.resource_name}-${sub?.id || sub?.display_name}`}
																	>
																		<a
																			href="#"
																			className={`group flex items-center rounded-lg p-[1.7px] text-white ${
																				selectedModule?.display_name === sub?.display_name
																					? "bg-blue-gray bg-opacity-20"
																					: "hover:bg-blue-gray hover:bg-opacity-20"
																			}`}
																			onClick={() => {
																				handleModuleClick(
																					`${module?.resource_name}/${sub.display_name}`,
																					sub.display_name,
																				);
																			}}
																		>
																			<span className="flex items-center">
																				<span className="flex items-center pl-[4px] text-white">
																					{sub.display_name}
																				</span>
																			</span>
																		</a>
																	</li>
																),
														)}
												</ul>
											</details>
										</li>
									),
							)}
					</div>
				</ul>
			</div>
		</aside>
	);
};

export default Sidebar;
